import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 mb-4 bg-white shadow-sm" }
const _hoisted_2 = { class: "card-header bg-light-subtle d-flex justify-content-between align-items-center py-3 px-4" }
const _hoisted_3 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-12 px-3 py-2"
}
const _hoisted_4 = {
  key: 1,
  class: "badge bg-warning-subtle text-warning fs-12 px-3 py-2"
}
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = {
  key: 0,
  class: "mb-4 p-3 rounded-3 bg-light border border-light-subtle"
}
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3" }
const _hoisted_8 = { class: "fw-bold text-primary mb-0" }
const _hoisted_9 = { class: "d-flex gap-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "row g-2 fs-13" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "fw-bold text-dark ms-1" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "fw-bold text-dark ms-1" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "fw-semibold text-dark ms-1" }
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mt-2 pt-2 border-top fs-12 text-muted" }
const _hoisted_23 = { class: "d-flex gap-3" }
const _hoisted_24 = { class: "text-dark ms-1" }
const _hoisted_25 = { class: "text-dark ms-1" }
const _hoisted_26 = { class: "material-symbols-outlined fs-14" }
const _hoisted_27 = {
  key: 0,
  class: "mt-3 pt-3 border-top"
}
const _hoisted_28 = { class: "p-2 mb-3 bg-white rounded border" }
const _hoisted_29 = { class: "row g-2 fs-12 text-dark" }
const _hoisted_30 = { class: "col-md-3" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = { class: "col-12 pt-1 border-top mt-1" }
const _hoisted_35 = { class: "badge bg-warning-subtle text-dark ms-1" }
const _hoisted_36 = { class: "mb-3" }
const _hoisted_37 = { class: "fw-bold fs-12 text-dark mb-1 d-flex align-items-center gap-1" }
const _hoisted_38 = { class: "badge bg-primary-subtle text-primary fs-10 ms-1" }
const _hoisted_39 = { class: "table-responsive" }
const _hoisted_40 = { class: "table table-sm table-bordered bg-white align-middle mb-0 fs-12" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-center fw-bold" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "fw-bold fs-12 text-dark mb-1 d-flex align-items-center gap-1" }
const _hoisted_46 = { class: "badge bg-warning-subtle text-dark fs-10 ms-1" }
const _hoisted_47 = { class: "table-responsive" }
const _hoisted_48 = { class: "table table-sm table-bordered bg-white align-middle mb-0 fs-12" }
const _hoisted_49 = { class: "text-center fw-bold text-danger" }
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = { class: "text-center text-muted fs-11" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_54 = { class: "card-body p-3" }
const _hoisted_55 = { class: "row mb-3" }
const _hoisted_56 = { class: "col-md-6 mb-2" }
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "col-md-6 mb-2" }
const _hoisted_59 = { class: "row mb-3" }
const _hoisted_60 = { class: "col-md-4 mb-2" }
const _hoisted_61 = { class: "col-md-4 mb-2" }
const _hoisted_62 = { class: "col-md-4 mb-2" }
const _hoisted_63 = { class: "row mb-3" }
const _hoisted_64 = { class: "col-md-4 mb-2" }
const _hoisted_65 = { class: "col-md-4 mb-2" }
const _hoisted_66 = { class: "col-md-4 mb-2" }
const _hoisted_67 = { class: "mb-0" }
const _hoisted_68 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_69 = { class: "card-header bg-light d-flex justify-content-between align-items-center py-2 px-3" }
const _hoisted_70 = { class: "badge bg-warning-subtle text-dark fs-11" }
const _hoisted_71 = { class: "card-body p-3" }
const _hoisted_72 = {
  key: 0,
  class: "mb-3 p-2 bg-white rounded border d-flex justify-content-between align-items-center flex-wrap gap-2"
}
const _hoisted_73 = { class: "d-flex align-items-center flex-wrap gap-2 fs-12" }
const _hoisted_74 = { class: "text-secondary" }
const _hoisted_75 = { class: "text-dark" }
const _hoisted_76 = { class: "text-dark" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-3 mb-2" }
const _hoisted_79 = { class: "col-md-3 mb-2" }
const _hoisted_80 = { class: "col-md-3 mb-2 d-flex align-items-center pt-3" }
const _hoisted_81 = { class: "form-check" }
const _hoisted_82 = { class: "col-md-3 mb-2 d-flex align-items-center pt-3" }
const _hoisted_83 = { class: "form-check" }
const _hoisted_84 = { class: "row mt-2 pt-2 border-top g-2 align-items-center" }
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_87 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-10"
}
const _hoisted_88 = { class: "input-group input-group-sm" }
const _hoisted_89 = ["placeholder"]
const _hoisted_90 = {
  key: 1,
  class: "input-group-text fs-12"
}
const _hoisted_91 = { class: "col-md-6 d-flex justify-content-between align-items-center pt-3" }
const _hoisted_92 = { class: "fs-12 text-secondary" }
const _hoisted_93 = { class: "text-dark" }
const _hoisted_94 = {
  id: "manualExclusionCard",
  class: "card border rounded-3 mb-4 shadow-sm"
}
const _hoisted_95 = { class: "card-header bg-light d-flex justify-content-between align-items-center py-2 px-3" }
const _hoisted_96 = { class: "d-flex align-items-center gap-2" }
const _hoisted_97 = { class: "badge bg-warning-subtle text-dark fs-11 ms-2" }
const _hoisted_98 = { class: "card-body p-3" }
const _hoisted_99 = {
  key: 0,
  class: "text-center py-3 text-muted fs-12 bg-light-subtle rounded border border-dashed"
}
const _hoisted_100 = { class: "mt-2" }
const _hoisted_101 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_102 = { class: "table table-sm table-bordered align-middle mb-0 fs-12" }
const _hoisted_103 = ["onUpdate:modelValue"]
const _hoisted_104 = ["onUpdate:modelValue"]
const _hoisted_105 = { class: "input-group input-group-sm" }
const _hoisted_106 = ["onUpdate:modelValue"]
const _hoisted_107 = ["onUpdate:modelValue"]
const _hoisted_108 = ["onUpdate:modelValue"]
const _hoisted_109 = ["onUpdate:modelValue"]
const _hoisted_110 = { class: "text-center" }
const _hoisted_111 = ["onClick"]
const _hoisted_112 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_113 = { class: "card-header bg-light d-flex justify-content-between align-items-center py-2 px-3" }
const _hoisted_114 = { class: "d-flex align-items-center gap-2" }
const _hoisted_115 = { class: "badge bg-primary-subtle text-primary fs-11" }
const _hoisted_116 = { class: "card-body p-3" }
const _hoisted_117 = {
  key: 0,
  class: "text-center py-3 text-muted fs-12 bg-light-subtle rounded border border-dashed"
}
const _hoisted_118 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_119 = { class: "table table-sm table-bordered align-middle mb-0 fs-12" }
const _hoisted_120 = { class: "text-center" }
const _hoisted_121 = ["onUpdate:modelValue"]
const _hoisted_122 = ["onUpdate:modelValue"]
const _hoisted_123 = { class: "input-group input-group-sm" }
const _hoisted_124 = ["onUpdate:modelValue"]
const _hoisted_125 = {
  key: 0,
  class: "text-danger fs-11 mt-1"
}
const _hoisted_126 = ["onUpdate:modelValue"]
const _hoisted_127 = ["onUpdate:modelValue"]
const _hoisted_128 = { class: "text-center" }
const _hoisted_129 = ["onClick"]
const _hoisted_130 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_131 = { class: "card-body p-3" }
const _hoisted_132 = { class: "row" }
const _hoisted_133 = { class: "col-md-3 mb-2" }
const _hoisted_134 = { class: "col-md-3 mb-2" }
const _hoisted_135 = { class: "col-md-3 mb-2" }
const _hoisted_136 = { class: "col-md-3 mb-2" }
const _hoisted_137 = { class: "col-md-4 mb-2" }
const _hoisted_138 = { class: "col-md-4 mb-2" }
const _hoisted_139 = { class: "col-md-4 mb-2" }
const _hoisted_140 = { class: "col-12 mt-2" }
const _hoisted_141 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_142 = { class: "card-body p-3" }
const _hoisted_143 = { class: "p-3 bg-light rounded-2 mb-3 border" }
const _hoisted_144 = { class: "row g-2 fs-12" }
const _hoisted_145 = { class: "col-md-4" }
const _hoisted_146 = { class: "form-check" }
const _hoisted_147 = { class: "col-md-4" }
const _hoisted_148 = { class: "form-check" }
const _hoisted_149 = { class: "col-md-4" }
const _hoisted_150 = { class: "form-check" }
const _hoisted_151 = { class: "col-md-4" }
const _hoisted_152 = { class: "form-check" }
const _hoisted_153 = { class: "col-md-4" }
const _hoisted_154 = { class: "form-check" }
const _hoisted_155 = { class: "col-md-4" }
const _hoisted_156 = { class: "form-check" }
const _hoisted_157 = { class: "row mb-3" }
const _hoisted_158 = { class: "col-md-4 mb-2" }
const _hoisted_159 = { class: "col-md-4 mb-2" }
const _hoisted_160 = { class: "col-md-4 mb-2" }
const _hoisted_161 = { class: "card bg-light-subtle border p-3 rounded-3 mb-3" }
const _hoisted_162 = { class: "row g-3" }
const _hoisted_163 = { class: "col-md-4" }
const _hoisted_164 = { class: "col-md-4" }
const _hoisted_165 = ["value"]
const _hoisted_166 = { class: "col-md-4" }
const _hoisted_167 = {
  key: 0,
  class: "col-12 mt-1"
}
const _hoisted_168 = { class: "d-flex align-items-center gap-3 p-2 bg-white rounded border" }
const _hoisted_169 = ["src"]
const _hoisted_170 = { class: "d-flex justify-content-end gap-2 mt-3 pt-3 border-top" }
const _hoisted_171 = ["disabled"]
const _hoisted_172 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
        _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-22" }, "fact_check"),
        _createElementVNode("h5", { class: "mb-0 fs-15 fw-bold text-dark" }, "Protokol Pemeriksaan Similaritas (SOP RBN-RC-SIM-01)")
      ], -1)),
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.protocol.protocol_number), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, " Belum Dibuat "))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "text-muted fs-12" }, "Nomor Protokol Resmi (SOP RBN-RC-SIM-01)", -1)),
                _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.protocol.protocol_number), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generatePdf && _ctx.generatePdf(...args))),
                  disabled: _ctx.generatingPdf,
                  class: "btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                }, [
                  (_ctx.generatingPdf)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                    : _createCommentVNode("", true),
                  _cache[49] || (_cache[49] = _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "picture_as_pdf", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.generatingPdf ? 'Membuat PDF...' : 'Regenerate PDF Protokol'), 1)
                ], 8, _hoisted_10),
                (_ctx.order.generated_protocol_pdf)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.getFileUrl(_ctx.order.generated_protocol_pdf),
                      target: "_blank",
                      class: "btn btn-sm btn-success d-flex align-items-center gap-1"
                    }, _cache[50] || (_cache[50] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "download", -1),
                      _createElementVNode("span", null, "Unduh Dokumen Resmi A4", -1)
                    ]), 8, _hoisted_12))
                  : _createCommentVNode("", true),
                (_ctx.protocol.verification?.verification_code)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: _ctx.getVerificationUrl(_ctx.protocol.verification.verification_code),
                      target: "_blank",
                      class: "btn btn-sm btn-info text-white d-flex align-items-center gap-1"
                    }, _cache[51] || (_cache[51] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "verified", -1),
                      _createElementVNode("span", null, "Cek Verifikasi Publik", -1)
                    ]), 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[52] || (_cache[52] = _createElementVNode("span", { class: "text-muted" }, "Skor Similaritas:", -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.protocol.overall_before) + "% → " + _toDisplayString(_ctx.protocol.overall_after) + "%", 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-muted" }, "Sumber Tertinggi:", -1)),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.protocol.highest_source_match) + "%", 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[54] || (_cache[54] = _createElementVNode("span", { class: "text-muted" }, "Status:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["badge ms-1", _ctx.protocol.result_status === 'Memenuhi' ? 'bg-success' : 'bg-danger'])
                }, _toDisplayString(_ctx.protocol.result_status), 3)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[55] || (_cache[55] = _createElementVNode("span", { class: "text-muted" }, "Rekomendasi:", -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.protocol.recommendation), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", null, [
                  _cache[56] || (_cache[56] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle text-primary" }, "format_list_numbered", -1)),
                  _createElementVNode("strong", _hoisted_24, _toDisplayString((_ctx.protocol.primary_sources || _ctx.protocol.primarySources || []).length), 1),
                  _cache[57] || (_cache[57] = _createTextVNode(" Primary Sources "))
                ]),
                _createElementVNode("div", null, [
                  _cache[58] || (_cache[58] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle text-warning" }, "rule", -1)),
                  _createElementVNode("strong", _hoisted_25, _toDisplayString((_ctx.protocol.manual_exclusions || _ctx.protocol.manualExclusions || []).length), 1),
                  _cache[59] || (_cache[59] = _createTextVNode(" Manual Source Exclusion "))
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-xs btn-outline-secondary fs-11 py-1 px-2 d-flex align-items-center gap-1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetailedOverview = !_ctx.showDetailedOverview))
              }, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.showDetailedOverview ? 'expand_less' : 'expand_more'), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.showDetailedOverview ? 'Tutup Rincian Tabel SOP' : 'Lihat Rincian Template Output (SOP)'), 1)
              ])
            ]),
            (_ctx.showDetailedOverview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[69] || (_cache[69] = _createElementVNode("div", { class: "fw-bold fs-12 text-secondary mb-2" }, "Pengaturan Pemeriksaan (SOP RBN-RC-SIM-01):", -1)),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _cache[60] || (_cache[60] = _createElementVNode("span", { class: "text-muted" }, "Repository:", -1)),
                        _cache[61] || (_cache[61] = _createTextVNode()),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.protocol.repository_setting || 'No repository'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _cache[62] || (_cache[62] = _createElementVNode("span", { class: "text-muted" }, "Exclude Bibliography:", -1)),
                        _cache[63] || (_cache[63] = _createTextVNode()),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.protocol.applied_exclude_biblio ? 'Excluded' : 'Included'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[64] || (_cache[64] = _createElementVNode("span", { class: "text-muted" }, "Exclude Quoted Material:", -1)),
                        _cache[65] || (_cache[65] = _createTextVNode()),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.protocol.applied_exclude_quotes ? 'Excluded' : 'Included'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _cache[66] || (_cache[66] = _createElementVNode("span", { class: "text-muted" }, "Exclude Small Matches:", -1)),
                        _cache[67] || (_cache[67] = _createTextVNode()),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.formatSmallMatches(_ctx.protocol)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _cache[68] || (_cache[68] = _createElementVNode("span", { class: "text-muted" }, "Manual Exclusion:", -1)),
                        _createElementVNode("span", _hoisted_35, _toDisplayString((_ctx.protocol.manual_exclusions || _ctx.protocol.manualExclusions || []).length) + " sumber", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _cache[70] || (_cache[70] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 text-primary" }, "format_list_numbered", -1)),
                      _cache[71] || (_cache[71] = _createElementVNode("span", null, "Primary Source Utama", -1)),
                      _createElementVNode("span", _hoisted_38, _toDisplayString((_ctx.protocol.primary_sources || _ctx.protocol.primarySources || []).length) + " Sumber ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("table", _hoisted_40, [
                        _cache[73] || (_cache[73] = _createElementVNode("thead", { class: "table-light" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              style: {"width":"5%"},
                              class: "text-center"
                            }, "No."),
                            _createElementVNode("th", { style: {"width":"45%"} }, "Sumber"),
                            _createElementVNode("th", {
                              style: {"width":"12%"},
                              class: "text-center"
                            }, "Match"),
                            _createElementVNode("th", {
                              style: {"width":"15%"},
                              class: "text-center"
                            }, "Status Review"),
                            _createElementVNode("th", { style: {"width":"23%"} }, "Catatan")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.protocol.primary_sources || _ctx.protocol.primarySources || []), (src, idx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                              _createElementVNode("td", _hoisted_41, _toDisplayString(src.source_rank || (idx + 1)), 1),
                              _createElementVNode("td", null, _toDisplayString(src.source_name), 1),
                              _createElementVNode("td", _hoisted_42, _toDisplayString(src.match_percentage) + "%", 1),
                              _createElementVNode("td", _hoisted_43, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", src.status === 'Wajar' ? 'bg-success-subtle text-success' : 'bg-warning-subtle text-warning-emphasis'])
                                }, _toDisplayString(src.status || 'Wajar'), 3)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(src.examiner_notes || '-'), 1)
                            ]))
                          }), 128)),
                          (!(_ctx.protocol.primary_sources || _ctx.protocol.primarySources || []).length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_44, _cache[72] || (_cache[72] = [
                                _createElementVNode("td", {
                                  colspan: "5",
                                  class: "text-center text-muted py-2"
                                }, "Belum ada data sumber primer tersimpan.", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_45, [
                      _cache[74] || (_cache[74] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 text-warning" }, "rule", -1)),
                      _cache[75] || (_cache[75] = _createElementVNode("span", null, "Manual Source Exclusion", -1)),
                      _createElementVNode("span", _hoisted_46, _toDisplayString((_ctx.protocol.manual_exclusions || _ctx.protocol.manualExclusions || []).length) + " Sumber ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("table", _hoisted_48, [
                        _cache[77] || (_cache[77] = _createElementVNode("thead", { class: "table-light" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { style: {"width":"32%"} }, "Sumber"),
                            _createElementVNode("th", {
                              style: {"width":"16%"},
                              class: "text-center"
                            }, "Match Sebelum Exclude"),
                            _createElementVNode("th", { style: {"width":"26%"} }, "Alasan"),
                            _createElementVNode("th", {
                              style: {"width":"12%"},
                              class: "text-center"
                            }, "Petugas"),
                            _createElementVNode("th", {
                              style: {"width":"14%"},
                              class: "text-center"
                            }, "Waktu")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.protocol.manual_exclusions || _ctx.protocol.manualExclusions || []), (exc, idx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                              _createElementVNode("td", null, _toDisplayString(exc.source_title_url), 1),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(exc.match_before) + "%", 1),
                              _createElementVNode("td", null, _toDisplayString(exc.exclusion_reason), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(exc.authorized_by), 1),
                              _createElementVNode("td", _hoisted_51, _toDisplayString(exc.excluded_at || '-'), 1)
                            ]))
                          }), 128)),
                          (!(_ctx.protocol.manual_exclusions || _ctx.protocol.manualExclusions || []).length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_52, _cache[76] || (_cache[76] = [
                                _createElementVNode("td", {
                                  colspan: "5",
                                  class: "text-center text-muted py-2"
                                }, " Tidak ada manual exclusion (Pemeriksaan mengikuti pengaturan filter standar). ", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[46] || (_cache[46] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveProtocol && _ctx.saveProtocol(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_53, [
          _cache[91] || (_cache[91] = _createElementVNode("div", { class: "card-header bg-light d-flex align-items-center gap-2 py-2 px-3" }, [
            _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "badge"),
            _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "2. Pemeriksaan Identitas & Parameter Pengujian (SOP RBN-RC-SIM-01)")
          ], -1)),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _cache[79] || (_cache[79] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Preset Ambang Batas (Similarity Profile)", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.profile_id) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onProfileChange && _ctx.onProfileChange(...args)))
                }, [
                  _cache[78] || (_cache[78] = _createElementVNode("option", { value: null }, "-- Custom / Bebas --", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profiles, (p) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: p.id,
                      value: p.id
                    }, _toDisplayString(p.service_classification) + " (Max " + _toDisplayString(p.default_max_overall) + "%, Single " + _toDisplayString(p.default_max_single_source) + "%) ", 9, _hoisted_57))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.form.profile_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _cache[81] || (_cache[81] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
                  _createTextVNode("Klasifikasi Dokumen "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.service_classification) = $event)),
                  required: ""
                }, _cache[80] || (_cache[80] = [
                  _createStaticVNode("<option value=\"Artikel Jurnal\">Artikel Jurnal</option><option value=\"JAD Dosen\">JAD Dosen</option><option value=\"Skripsi/Tesis/Disertasi\">Skripsi/Tesis/Disertasi</option><option value=\"Proposal\">Proposal</option><option value=\"Laporan\">Laporan</option><option value=\"Lainnya\">Lainnya</option>", 6)
                ]), 512), [
                  [_vModelSelect, _ctx.form.service_classification]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _cache[82] || (_cache[82] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Perangkat Lunak Penguji", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.tool_name) = $event)),
                  required: "",
                  placeholder: "Turnitin / iThenticate"
                }, null, 512), [
                  [_vModelText, _ctx.form.tool_name]
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _cache[84] || (_cache[84] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
                  _createTextVNode("Setting Repositori "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.repository_setting) = $event)),
                  required: ""
                }, _cache[83] || (_cache[83] = [
                  _createElementVNode("option", { value: "No repository" }, "No repository (Wajib SOP RBN)", -1),
                  _createElementVNode("option", { value: "Standard repository" }, "Standard repository", -1),
                  _createElementVNode("option", { value: "Sesuai kebijakan akun" }, "Sesuai kebijakan akun", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.repository_setting]
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _cache[86] || (_cache[86] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Versi Naskah", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.manuscript_version) = $event))
                }, _cache[85] || (_cache[85] = [
                  _createElementVNode("option", { value: "Draft" }, "Draft", -1),
                  _createElementVNode("option", { value: "Accepted manuscript" }, "Accepted manuscript", -1),
                  _createElementVNode("option", { value: "Published version" }, "Published version", -1),
                  _createElementVNode("option", { value: "Lainnya" }, "Lainnya", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.manuscript_version]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _cache[87] || (_cache[87] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "ID Laporan / Submission ID", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.report_submission_id) = $event)),
                  placeholder: "cth: 219830219"
                }, null, 512), [
                  [_vModelText, _ctx.form.report_submission_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _cache[88] || (_cache[88] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Akun Pemeriksa Turnitin", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.examiner_account) = $event)),
                  placeholder: "cth: Turnitin PT RBN Official"
                }, null, 512), [
                  [_vModelText, _ctx.form.examiner_account]
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _cache[89] || (_cache[89] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Tanggal Laporan Software", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.report_date) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.report_date]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_67, [
              _cache[90] || (_cache[90] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "SHA-256 Hash Naskah", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-sm font-monospace",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.file_hash_sha256) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.file_hash_sha256]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _cache[92] || (_cache[92] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
              _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "tune"),
              _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "3. Pengaturan Pemeriksaan & Parameter Ambang Batas (Snapshot Override)")
            ], -1)),
            _createElementVNode("span", _hoisted_70, " Manual Exclusion: " + _toDisplayString(_ctx.form.manual_exclusions.length) + " sumber ", 1)
          ]),
          _createElementVNode("div", _hoisted_71, [
            (_ctx.orderRequirement)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _cache[96] || (_cache[96] = _createElementVNode("span", { class: "badge bg-primary-subtle text-primary fs-11" }, "Pilihan Pelanggan pada Pesanan", -1)),
                    _createElementVNode("span", _hoisted_74, [
                      _cache[93] || (_cache[93] = _createTextVNode(" Exclude Quotes: ")),
                      _createElementVNode("strong", _hoisted_75, _toDisplayString(_ctx.orderRequirement.excludeQuotes ? 'Ya' : 'Tidak'), 1),
                      _cache[94] || (_cache[94] = _createTextVNode(" • Exclude Biblio: ")),
                      _createElementVNode("strong", _hoisted_76, _toDisplayString(_ctx.orderRequirement.excludeBiblio ? 'Ya' : 'Tidak'), 1),
                      _cache[95] || (_cache[95] = _createTextVNode(" • Exclude Match: ")),
                      _createElementVNode("strong", {
                        class: _normalizeClass(_ctx.orderRequirement.excludeMatch ? 'text-success' : 'text-secondary')
                      }, _toDisplayString(_ctx.orderRequirement.excludeMatch ? 'Ya (Aktif)' : 'Tidak (None)'), 3)
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-xs btn-outline-primary py-0 px-2 fs-11 d-inline-flex align-items-center gap-1",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.syncFromOrderRequirements(true)))
                  }, _cache[97] || (_cache[97] = [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "sync", -1),
                    _createElementVNode("span", null, "Sinkronkan ke Form", -1)
                  ]))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _cache[98] || (_cache[98] = _createElementVNode("label", { class: "form-label fs-12" }, "Maks. Total (%)", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.applied_max_overall) = $event)),
                  onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onThresholdChange && _ctx.onThresholdChange(...args))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.form.applied_max_overall]
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _cache[99] || (_cache[99] = _createElementVNode("label", { class: "form-label fs-12" }, "Maks. Sumber Tunggal (%)", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.applied_max_single_source) = $event)),
                  onInput: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onThresholdChange && _ctx.onThresholdChange(...args))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.form.applied_max_single_source]
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: "biblioCheck",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.applied_exclude_biblio) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.applied_exclude_biblio]
                  ]),
                  _cache[100] || (_cache[100] = _createElementVNode("label", {
                    class: "form-check-label fs-12",
                    for: "biblioCheck"
                  }, "Exclude Bibliografi", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: "quotesCheck",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.applied_exclude_quotes) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.applied_exclude_quotes]
                  ]),
                  _cache[101] || (_cache[101] = _createElementVNode("label", {
                    class: "form-check-label fs-12",
                    for: "quotesCheck"
                  }, "Exclude Quotes", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _cache[102] || (_cache[102] = _createElementVNode("label", { class: "form-label fs-12 mb-0" }, "Exclude Small Matches (Filter Kecocokan Kecil)", -1)),
                  (_ctx.orderRequirement?.excludeMatch)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_87, "Pilihan Pelanggan: Aktif"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.small_matches_mode) = $event))
                  }, _cache[103] || (_cache[103] = [
                    _createElementVNode("option", { value: "none" }, "Tidak / None", -1),
                    _createElementVNode("option", { value: "words" }, "Words (Jumlah Kata)", -1),
                    _createElementVNode("option", { value: "percentage" }, "Percentage (%)", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.form.small_matches_mode]
                  ]),
                  (_ctx.form.small_matches_mode !== 'none')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "number",
                        min: "1",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.small_matches_value) = $event)),
                        placeholder: _ctx.form.small_matches_mode === 'words' ? 'cth: 8' : 'cth: 1'
                      }, null, 8, _hoisted_89)), [
                        [
                          _vModelText,
                          _ctx.form.small_matches_value,
                          void 0,
                          { number: true }
                        ]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.form.small_matches_mode !== 'none')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(_ctx.form.small_matches_mode === 'words' ? 'kata' : '%'), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("span", _hoisted_92, [
                  _cache[104] || (_cache[104] = _createTextVNode(" Manual Source Exclusion: ")),
                  _createElementVNode("strong", _hoisted_93, _toDisplayString(_ctx.form.manual_exclusions.length) + " sumber dicatat", 1)
                ]),
                _cache[105] || (_cache[105] = _createElementVNode("a", {
                  href: "#manualExclusionCard",
                  class: "btn btn-xs btn-outline-warning text-dark fs-12 py-1 px-2 d-inline-flex align-items-center gap-1"
                }, [
                  _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "rule"),
                  _createElementVNode("span", null, "Kelola Manual Source Exclusion")
                ], -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _cache[107] || (_cache[107] = _createElementVNode("span", { class: "material-symbols-outlined text-warning fs-18" }, "rule", -1)),
              _createElementVNode("div", null, [
                _cache[106] || (_cache[106] = _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "4. Manual Source Exclusion (Log Eksklusi Manual Sumber) - SOP RBN-RC-SIM-01", -1)),
                _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.form.manual_exclusions.length) + " Sumber Dieksklusi", 1)
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.addManualExclusion && _ctx.addManualExclusion(...args))),
              class: "btn btn-xs btn-warning text-dark d-flex align-items-center gap-1 py-1 px-2 fs-12 fw-medium shadow-sm"
            }, _cache[108] || (_cache[108] = [
              _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "add", -1),
              _createElementVNode("span", null, "Tambah Manual Source Exclusion", -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_98, [
            _cache[117] || (_cache[117] = _createElementVNode("p", { class: "fs-12 text-muted mb-2" }, [
              _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle text-primary" }, "info"),
              _createElementVNode("strong", null, "Blok 2 Template Output Resmi (RBN-RC-WEB-SIM-01)"),
              _createTextVNode(": Sesuai SOP, jika pemeriksa mengecualikan kecocokan tertentu (seperti publikasi/preprint milik penulis sendiri, repository institusi, atau template resmi), cantumkan rincian dan alasannya demi audit kepatuhan integritas akademik. ")
            ], -1)),
            (_ctx.form.manual_exclusions.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                  _cache[110] || (_cache[110] = _createElementVNode("span", { class: "material-symbols-outlined fs-24 d-block mb-1 text-secondary" }, "verified_user", -1)),
                  _cache[111] || (_cache[111] = _createTextVNode(" Tidak ada sumber yang dieksklusi secara manual (Pemeriksaan mengikuti pengaturan filter standar Turnitin). ")),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addManualExclusion && _ctx.addManualExclusion(...args))),
                      class: "btn btn-xs btn-outline-warning text-dark fs-12 py-1 px-2"
                    }, _cache[109] || (_cache[109] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle" }, "add", -1),
                      _createTextVNode(" Tambah Manual Source Exclusion ")
                    ]))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  _createElementVNode("table", _hoisted_102, [
                    _cache[116] || (_cache[116] = _createElementVNode("thead", { class: "table-light" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { style: {"width":"27%"} }, [
                          _createTextVNode("Sumber / Dokumen / URL "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ]),
                        _createElementVNode("th", { style: {"width":"14%"} }, "Tipe Sumber"),
                        _createElementVNode("th", {
                          style: {"width":"12%"},
                          class: "text-center"
                        }, [
                          _createTextVNode("Match Sblm Exclude (%) "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ]),
                        _createElementVNode("th", { style: {"width":"21%"} }, [
                          _createTextVNode("Alasan Justifikasi Akademik "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ]),
                        _createElementVNode("th", { style: {"width":"11%"} }, "Petugas"),
                        _createElementVNode("th", { style: {"width":"11%"} }, "Waktu Exclude"),
                        _createElementVNode("th", {
                          style: {"width":"4%"},
                          class: "text-center"
                        }, "Aksi")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.manual_exclusions, (exc, idx) => {
                        return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              "onUpdate:modelValue": ($event: any) => ((exc.source_title_url) = $event),
                              placeholder: "cth: Preprint Penulis di ResearchGate",
                              required: ""
                            }, null, 8, _hoisted_103), [
                              [_vModelText, exc.source_title_url]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select form-select-sm",
                              "onUpdate:modelValue": ($event: any) => ((exc.source_type) = $event)
                            }, _cache[112] || (_cache[112] = [
                              _createElementVNode("option", { value: "Self-match" }, "Self-match", -1),
                              _createElementVNode("option", { value: "Bibliografi" }, "Bibliografi", -1),
                              _createElementVNode("option", { value: "Quote" }, "Quote", -1),
                              _createElementVNode("option", { value: "Lainnya" }, "Lainnya", -1)
                            ]), 8, _hoisted_104), [
                              [_vModelSelect, exc.source_type]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_105, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                step: "0.1",
                                class: "form-control form-control-sm text-center",
                                "onUpdate:modelValue": ($event: any) => ((exc.match_before) = $event),
                                required: ""
                              }, null, 8, _hoisted_106), [
                                [
                                  _vModelText,
                                  exc.match_before,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _cache[113] || (_cache[113] = _createElementVNode("span", { class: "input-group-text px-1" }, "%", -1))
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              "onUpdate:modelValue": ($event: any) => ((exc.exclusion_reason) = $event),
                              placeholder: "cth: Publikasi skripsi penulis sendiri yang sudah terbit",
                              required: ""
                            }, null, 8, _hoisted_107), [
                              [_vModelText, exc.exclusion_reason]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select form-select-sm",
                              "onUpdate:modelValue": ($event: any) => ((exc.authorized_by) = $event)
                            }, _cache[114] || (_cache[114] = [
                              _createElementVNode("option", { value: "Pemeriksa" }, "Pemeriksa", -1),
                              _createElementVNode("option", { value: "QC" }, "QC", -1)
                            ]), 8, _hoisted_108), [
                              [_vModelSelect, exc.authorized_by]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm text-center fs-11",
                              "onUpdate:modelValue": ($event: any) => ((exc.excluded_at) = $event),
                              placeholder: "YYYY-MM-DD HH:mm:ss"
                            }, null, 8, _hoisted_109), [
                              [_vModelText, exc.excluded_at]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_110, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeManualExclusion(idx)),
                              class: "btn btn-sm btn-outline-danger p-1 border-0",
                              title: "Hapus Manual Exclusion"
                            }, _cache[115] || (_cache[115] = [
                              _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "delete", -1)
                            ]), 8, _hoisted_111)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_112, [
          _createElementVNode("div", _hoisted_113, [
            _createElementVNode("div", _hoisted_114, [
              _cache[118] || (_cache[118] = _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "format_list_numbered", -1)),
              _cache[119] || (_cache[119] = _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "5. Daftar Sumber Kecocokan Utama (Primary Sources)", -1)),
              _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.form.primary_sources.length) + " Sumber", 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.addPrimarySource && _ctx.addPrimarySource(...args))),
              class: "btn btn-xs btn-primary d-flex align-items-center gap-1 py-1 px-2 fs-12"
            }, _cache[120] || (_cache[120] = [
              _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "add", -1),
              _createElementVNode("span", null, "Tambah Sumber Primer", -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_116, [
            (_ctx.form.primary_sources.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_117, _cache[121] || (_cache[121] = [
                  _createElementVNode("span", { class: "material-symbols-outlined fs-24 d-block mb-1 text-secondary" }, "menu_book", -1),
                  _createTextVNode(" Belum ada sumber primer yang dicatat. Klik "),
                  _createElementVNode("strong", null, "\"Tambah Sumber Primer\"", -1),
                  _createTextVNode(" untuk mencatat sumber Turnitin utama. ")
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_118, [
                  _createElementVNode("table", _hoisted_119, [
                    _cache[125] || (_cache[125] = _createElementVNode("thead", { class: "table-light" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          style: {"width":"7%"},
                          class: "text-center"
                        }, "# Rank"),
                        _createElementVNode("th", { style: {"width":"38%"} }, [
                          _createTextVNode("Nama Sumber / Publikasi / URL "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ]),
                        _createElementVNode("th", {
                          style: {"width":"15%"},
                          class: "text-center"
                        }, [
                          _createTextVNode("Kecocokan (%) "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ]),
                        _createElementVNode("th", { style: {"width":"15%"} }, "Status Penilaian"),
                        _createElementVNode("th", { style: {"width":"20%"} }, "Catatan / Tindakan"),
                        _createElementVNode("th", {
                          style: {"width":"5%"},
                          class: "text-center"
                        }, "Aksi")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.primary_sources, (source, idx) => {
                        return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                          _createElementVNode("td", _hoisted_120, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control form-control-sm text-center px-1",
                              "onUpdate:modelValue": ($event: any) => ((source.source_rank) = $event),
                              min: "1"
                            }, null, 8, _hoisted_121), [
                              [
                                _vModelText,
                                source.source_rank,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              "onUpdate:modelValue": ($event: any) => ((source.source_name) = $event),
                              placeholder: "cth: repository.unair.ac.id / IEEE Xplore",
                              required: ""
                            }, null, 8, _hoisted_122), [
                              [_vModelText, source.source_name]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_123, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                step: "0.1",
                                class: "form-control form-control-sm text-center",
                                "onUpdate:modelValue": ($event: any) => ((source.match_percentage) = $event),
                                required: ""
                              }, null, 8, _hoisted_124), [
                                [
                                  _vModelText,
                                  source.match_percentage,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _cache[122] || (_cache[122] = _createElementVNode("span", { class: "input-group-text px-1" }, "%", -1))
                            ]),
                            (source.match_percentage > _ctx.form.applied_max_single_source)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_125, " > Ambang (" + _toDisplayString(_ctx.form.applied_max_single_source) + "%) ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select form-select-sm",
                              "onUpdate:modelValue": ($event: any) => ((source.status) = $event)
                            }, _cache[123] || (_cache[123] = [
                              _createElementVNode("option", { value: "Wajar" }, "Wajar", -1),
                              _createElementVNode("option", { value: "Perlu revisi" }, "Perlu revisi", -1),
                              _createElementVNode("option", { value: "Klarifikasi" }, "Klarifikasi", -1)
                            ]), 8, _hoisted_126), [
                              [_vModelSelect, source.status]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              "onUpdate:modelValue": ($event: any) => ((source.examiner_notes) = $event),
                              placeholder: "cth: Dikutip resmi / Parafrase"
                            }, null, 8, _hoisted_127), [
                              [_vModelText, source.examiner_notes]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_128, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.removePrimarySource(idx)),
                              class: "btn btn-sm btn-outline-danger p-1 border-0",
                              title: "Hapus Sumber"
                            }, _cache[124] || (_cache[124] = [
                              _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "delete", -1)
                            ]), 8, _hoisted_129)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_130, [
          _cache[136] || (_cache[136] = _createStaticVNode("<div class=\"card-header bg-light d-flex align-items-center justify-content-between py-2 px-3\"><div class=\"d-flex align-items-center gap-2\"><span class=\"material-symbols-outlined text-primary fs-18\">analytics</span><span class=\"fw-bold fs-13 text-dark\">6. Hasil Pengukuran Similaritas</span></div><span class=\"badge bg-primary-subtle text-primary fs-11 d-inline-flex align-items-center gap-1\"><span class=\"material-symbols-outlined fs-13\">auto_awesome</span><span>Auto-Kalkulasi Aktif (Dapat Diedit)</span></span></div>", 1)),
          _createElementVNode("div", _hoisted_131, [
            _createElementVNode("div", _hoisted_132, [
              _createElementVNode("div", _hoisted_133, [
                _cache[126] || (_cache[126] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Skor Awal (%) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.overall_before) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.overall_before]
                ])
              ]),
              _createElementVNode("div", _hoisted_134, [
                _cache[127] || (_cache[127] = _createElementVNode("label", { class: "form-label fs-12 d-flex justify-content-between" }, [
                  _createElementVNode("span", null, [
                    _createTextVNode("Skor Akhir / Pasca-QC (%) "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ]),
                  _createElementVNode("span", { class: "text-muted fs-10" }, "(Total Sumber)")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.overall_after) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.overall_after]
                ])
              ]),
              _createElementVNode("div", _hoisted_135, [
                _cache[128] || (_cache[128] = _createElementVNode("label", { class: "form-label fs-12 d-flex justify-content-between" }, [
                  _createElementVNode("span", null, [
                    _createTextVNode("Kecocokan Tertinggi (%) "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ]),
                  _createElementVNode("span", { class: "text-muted fs-10" }, "(Maks Sumber)")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.highest_source_match) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.highest_source_match]
                ])
              ]),
              _createElementVNode("div", _hoisted_136, [
                _cache[129] || (_cache[129] = _createElementVNode("label", { class: "form-label fs-12" }, "Nama Sumber Tertinggi", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.highest_source_name) = $event)),
                  placeholder: "cth: repository.unair.ac.id"
                }, null, 512), [
                  [_vModelText, _ctx.form.highest_source_name]
                ])
              ]),
              _createElementVNode("div", _hoisted_137, [
                _cache[130] || (_cache[130] = _createElementVNode("label", { class: "form-label fs-12" }, "Sumber Melampaui Batas (Count)", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.sources_above_threshold_count) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.sources_above_threshold_count]
                ])
              ]),
              _createElementVNode("div", _hoisted_138, [
                _cache[132] || (_cache[132] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Status Pengujian "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.result_status) = $event)),
                  required: ""
                }, _cache[131] || (_cache[131] = [
                  _createElementVNode("option", { value: "Memenuhi" }, "Memenuhi", -1),
                  _createElementVNode("option", { value: "Perlu revisi" }, "Perlu revisi", -1),
                  _createElementVNode("option", { value: "Perlu klarifikasi" }, "Perlu klarifikasi", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.result_status]
                ])
              ]),
              _createElementVNode("div", _hoisted_139, [
                _cache[134] || (_cache[134] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Rekomendasi "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.recommendation) = $event)),
                  required: ""
                }, _cache[133] || (_cache[133] = [
                  _createElementVNode("option", { value: "Layak diterbitkan" }, "Layak diterbitkan", -1),
                  _createElementVNode("option", { value: "Revisi naskah dan pemeriksaan ulang" }, "Revisi naskah dan pemeriksaan ulang", -1),
                  _createElementVNode("option", { value: "Klarifikasi sumber" }, "Klarifikasi sumber", -1),
                  _createElementVNode("option", { value: "Eskalasi ke QC" }, "Eskalasi ke QC", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.recommendation]
                ])
              ]),
              _createElementVNode("div", _hoisted_140, [
                _cache[135] || (_cache[135] = _createElementVNode("label", { class: "form-label fs-12" }, "Catatan Rekomendasi", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control form-control-sm",
                  rows: "2",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.recommendation_notes) = $event)),
                  placeholder: "Catatan kesimpulan hasil pemeriksaan..."
                }, null, 512), [
                  [_vModelText, _ctx.form.recommendation_notes]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_141, [
          _cache[155] || (_cache[155] = _createElementVNode("div", { class: "card-header bg-light d-flex align-items-center gap-2 py-2 px-3" }, [
            _createElementVNode("span", { class: "material-symbols-outlined text-success fs-18" }, "verified"),
            _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "7. Pemeriksaan Integritas Akademik & Pengesahan")
          ], -1)),
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _cache[143] || (_cache[143] = _createElementVNode("div", { class: "fw-bold fs-13 mb-2 text-dark" }, "Verifikasi 6 Parameter Integritas Akademik", -1)),
              _createElementVNode("div", _hoisted_144, [
                _createElementVNode("div", _hoisted_145, [
                  _createElementVNode("div", _hoisted_146, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.integrity_plagiarism) = $event)),
                      id: "intPlag"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.integrity_plagiarism]
                    ]),
                    _cache[137] || (_cache[137] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "intPlag"
                    }, "Bebas Plagiarisme Substantif", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_147, [
                  _createElementVNode("div", _hoisted_148, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.integrity_fabrication) = $event)),
                      id: "intFab"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.integrity_fabrication]
                    ]),
                    _cache[138] || (_cache[138] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "intFab"
                    }, "Bebas Fabrikasi Data", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("div", _hoisted_150, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.integrity_falsification) = $event)),
                      id: "intFals"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.integrity_falsification]
                    ]),
                    _cache[139] || (_cache[139] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "intFals"
                    }, "Bebas Falsifikasi Hasil", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_151, [
                  _createElementVNode("div", _hoisted_152, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.integrity_duplicate) = $event)),
                      id: "intDup"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.integrity_duplicate]
                    ]),
                    _cache[140] || (_cache[140] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "intDup"
                    }, "Bebas Redundan / Duplikasi", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_153, [
                  _createElementVNode("div", _hoisted_154, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.integrity_authorship) = $event)),
                      id: "intAuth"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.integrity_authorship]
                    ]),
                    _cache[141] || (_cache[141] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "intAuth"
                    }, "Validitas Kepengarangan", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_155, [
                  _createElementVNode("div", _hoisted_156, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.integrity_coi) = $event)),
                      id: "intCoi"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.integrity_coi]
                    ]),
                    _cache[142] || (_cache[142] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "intCoi"
                    }, "Bebas Konflik Kepentingan", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_157, [
              _createElementVNode("div", _hoisted_158, [
                _cache[144] || (_cache[144] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Nama Penulis (Masked Publik)", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.author_name_masked) = $event)),
                  required: "",
                  placeholder: "cth: A*** S***"
                }, null, 512), [
                  [_vModelText, _ctx.form.author_name_masked]
                ])
              ]),
              _createElementVNode("div", _hoisted_159, [
                _cache[145] || (_cache[145] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Judul Dokumen (Masked Publik)", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.document_title_masked) = $event)),
                  required: "",
                  placeholder: "cth: Analisis Dampak..."
                }, null, 512), [
                  [_vModelText, _ctx.form.document_title_masked]
                ])
              ]),
              _createElementVNode("div", _hoisted_160, [
                _cache[146] || (_cache[146] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Institusi / Afiliasi", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.institution) = $event)),
                  placeholder: "Universitas ..."
                }, null, 512), [
                  [_vModelText, _ctx.form.institution]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_161, [
              _cache[153] || (_cache[153] = _createElementVNode("h6", { class: "fs-13 fw-bold text-dark mb-2 d-flex align-items-center gap-1" }, [
                _createElementVNode("span", { class: "material-symbols-outlined fs-18 text-primary" }, "draw"),
                _createElementVNode("span", null, "Pemeriksa & Penandatangan Pengesahan Protokol")
              ], -1)),
              _createElementVNode("div", _hoisted_162, [
                _createElementVNode("div", _hoisted_163, [
                  _cache[147] || (_cache[147] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, [
                    _createTextVNode("Nama Pemeriksa (Examiner) "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.examiner_name) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.examiner_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_164, [
                  _cache[149] || (_cache[149] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Pilih Penandatangan Terdaftar", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm",
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.signatory_id) = $event)),
                    onChange: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.onSignatoryChange && _ctx.onSignatoryChange(...args)))
                  }, [
                    _cache[148] || (_cache[148] = _createElementVNode("option", { value: null }, "-- Gunakan Penandatangan Default --", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatories, (sig) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: sig.id,
                        value: sig.id
                      }, _toDisplayString(sig.name) + " (" + _toDisplayString(sig.position) + ") " + _toDisplayString(sig.is_default ? '★ Default' : ''), 9, _hoisted_165))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.form.signatory_id]
                  ])
                ]),
                _createElementVNode("div", _hoisted_166, [
                  _cache[150] || (_cache[150] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Nama & Jabatan Pengesahan", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm mb-1",
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.signatory_name) = $event)),
                    placeholder: "Nama penandatangan"
                  }, null, 512), [
                    [_vModelText, _ctx.form.signatory_name]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.signatory_position) = $event)),
                    placeholder: "Jabatan penandatangan"
                  }, null, 512), [
                    [_vModelText, _ctx.form.signatory_position]
                  ])
                ]),
                (_ctx.selectedSignatoryPreviewUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                      _createElementVNode("div", _hoisted_168, [
                        _cache[151] || (_cache[151] = _createElementVNode("span", { class: "fs-11 text-muted fw-semibold" }, "Preview Tanda Tangan:", -1)),
                        _createElementVNode("img", {
                          src: _ctx.selectedSignatoryPreviewUrl,
                          alt: "Tanda Tangan",
                          style: {"height":"32px","max-width":"120px","object-fit":"contain"}
                        }, null, 8, _hoisted_169),
                        _cache[152] || (_cache[152] = _createElementVNode("span", { class: "fs-11 text-success d-flex align-items-center gap-1" }, [
                          _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "check_circle"),
                          _createElementVNode("span", null, "Siap disematkan pada sertifikat protokol")
                        ], -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_170, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary px-4 py-2 d-flex align-items-center gap-2",
                disabled: _ctx.submitting
              }, [
                (_ctx.submitting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_172))
                  : _createCommentVNode("", true),
                _cache[154] || (_cache[154] = _createElementVNode("span", { class: "material-symbols-outlined fs-18" }, "save", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.protocol ? 'Perbarui Protokol' : 'Simpan & Terbitkan Protokol RC-SIM'), 1)
              ], 8, _hoisted_171)
            ])
          ])
        ])
      ], 32)
    ])
  ]))
}